import script from "./Styles.vue?vue&type=script&setup=true&lang=ts"
export * from "./Styles.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./Styles.vue?vue&type=style&index=0&id=be5b1dce&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__